import React, { ChangeEvent, CSSProperties, FormEvent, SyntheticEvent, useEffect, useState } from 'react'
import ProjectHandler from '../../Database/handlers/ProjectHandler'
import TodoHandler from '../../Database/handlers/TodoHandler'
import useDrawer from '../../hooks/useDrawer'
import useLocalStorage from '../../hooks/useLocalStorage'
import useModal from '../../hooks/useModal'
import useToast from '../../hooks/useToast'
import { IProjectDetails } from '../../types/interfaces'
import ComputeReadableDuration from '../../Utilities/ComputeReadableDuration'
import CreateNotif from '../../Utilities/CreateNotif'
import PieChart from '../Charts/PieChart/PieChart'
import "../DashBoardPage/DashBoardPage.css"
import Drawer from '../Drawer/Drawer'
import Modal from '../Modal/Modal'
import Toastlist from '../ToastsList/ToastsList'
export default function DashBoardPage() {
  const projectHandler = new ProjectHandler()
  const todoHandler = new TodoHandler()
  const [toastsArr, setToasts, deleteToast] = useToast()
  const [isOpen,toggleModal] = useModal()
  const [project, setProject] = useLocalStorage("project", {
    "id":"",
    "AuthorName": "",
    "ProjectName": "",
    "ProjectDeadline": new Date(),
    "Project":""
  })
  const [CreateDrawerIsOpen,toggleCreateDrawer] = useDrawer()
  const [EditDrawerIsOpen,toggleEditDrawer] = useDrawer()
  const [AppTheme,setAppTheme] = useLocalStorage("theme",undefined)
  const [state, setstate] = useState<{
    projects:IProjectDetails[],
    currentProject: {
      id:number,author:string,projectName:string,deadline:Date
    }
    DetailsFields: {[key:string]:string},
    PieChartData: {
      data: { label: string, value: number }[],
      colorMap: { [key: string]: string }
    }
  }>({
    projects: [], currentProject: {
      id: parseInt(project.id),
      author: project.AuthorName,
      projectName:project.ProjectName,
      deadline: new Date(project.ProjectDeadline)
    },
    PieChartData: { data: [], colorMap: {} },
    DetailsFields: {
      "id":"",
      "AuthorName": "",
      "ProjectName": "",
      "ProjectDeadline": "",
      "Project":""
    }
  })
  function Setthemetemp(event:React.MouseEvent<HTMLDivElement>) {
    console.log(event.currentTarget.className)
    const container = document.querySelector("#root") as HTMLElement
    container.className = `root ${event.currentTarget.className}`
    setAppTheme(event.currentTarget.className)
  }
  
  useEffect(() => {
    
    projectHandler.FetchProjects().then((data) => {
      CreateAnalyticsData("Status")
      // if (project.id == undefined) {
      //   console.log("not avaiablabe")
      //   const defaultProject = data.find((item)=>item.projectName=="None" && item.author=="Guest")
      //   setstate({...state, projects: data, DetailsFields: {
      //   "id": defaultProject?.id?.toString()||"",
      //   "AuthorName": defaultProject?.author||"",
      //   "ProjectName": defaultProject?.projectName||"",
      //   "ProjectDeadline": defaultProject?.deadline.toISOString().split("T")[0]||"",
      //   "Project": defaultProject?.projectName||""
      //   },currentProject:{
      //     id:defaultProject?.id||0,
      //     author:defaultProject?.author||"",
      //     deadline:new Date(defaultProject?.deadline||""),
      //     projectName:defaultProject?.projectName||""
      //   }
      // })
      // }else{
        
      // } 
      // if (project.id == "") {
      //   const defaultProject = data.find((item) => item.projectName == "None" && item.author == "Guest")
      //   console.log(defaultProject)
      //   setstate({...state, projects: data, DetailsFields: {
      //   "id": defaultProject?.id?.toString()||"",
      //   "AuthorName": defaultProject?.author||"",
      //   "ProjectName": defaultProject?.projectName||"",
      //   "ProjectDeadline": defaultProject?.deadline.toISOString().split("T")[0]||"",
      //   "Project": defaultProject?.projectName||""
      //   },currentProject:{
      //     id:defaultProject?.id||0,
      //     author:defaultProject?.author||"",
      //     deadline:new Date(defaultProject?.deadline||""),
      //     projectName:defaultProject?.projectName||""
      //     }
      //   })
      //   setProject({})
      // }
      if (state.currentProject.author != "") {
        console.log("called",state.currentProject)
        setstate({...state, projects: data, DetailsFields: {
        "id": state.currentProject.id?.toString()||"",
        "AuthorName": state.currentProject.author||"",
        "ProjectName": state.currentProject.projectName||"",
        "ProjectDeadline": state.currentProject.deadline?.toISOString().split("T")[0]||"",
        "Project": state.currentProject.projectName||""
      }})
      } else {
        console.log(project,"call")
        setstate({...state, projects: data, currentProject: {
        id: project.id,
        author: project.author,
        projectName: project.projectName,
        deadline: project.deadline,
        }})
      }
      
    
      if (!project || project.id == "" || !project.id) {
        setProject({
          "id": data[0].id?.toString() || "",
          "AuthorName": data[0].author,
          "ProjectName": data[0].projectName,
          "ProjectDeadline": data[0].deadline.toISOString().split("T")[0] || "",
          "Project": data[0].projectName
        })
        setstate({
          ...state, projects: data, DetailsFields: {
            "id": data[0].id?.toString() || "",
            "AuthorName": data[0].author || "",
            "ProjectName": data[0].projectName || "",
            "ProjectDeadline": data[0].deadline.toISOString().split("T")[0] || "",
            "Project": data[0].projectName || ""
          }, currentProject: {
            id: data[0].id || 0,
            author: data[0].author || "",
            deadline: new Date(data[0].deadline || ""),
            projectName: data[0].projectName || ""
          }
        })
      }
     })
    
  }, [project, state.currentProject])
  

  function HandleCreateProject(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    console.log(event.currentTarget.elements)
    const AuthorInput = event.currentTarget.elements[1] as HTMLInputElement
    const ProjectNameInput = event.currentTarget.elements[0] as HTMLInputElement
    const DeadlineInput = event.currentTarget.elements[2] as HTMLInputElement
    const data:IProjectDetails = {
      author: AuthorInput.value,
      projectName: ProjectNameInput.value,
      deadline: new Date(DeadlineInput.value),
    }
    console.log(state.projects.find((item)=>item.id?.toString()||"" == project.id))
    if(state.projects.find((item)=>item.projectName == data.projectName)?.projectName == data.projectName) return
    if(data.projectName == "None") return
    projectHandler.CreateProject(data).then(() => {
      projectHandler.FetchProjects().then((projects) => {
        setstate({...state, projects})
        setToasts(toastsArr.length + 1, "Created new project" , "", deleteToast)
      })
      
    })
    toggleCreateDrawer()
  }

  function HandleEditProject(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    console.log(event.currentTarget.elements)
    const AuthorInput = event.currentTarget.elements[1] as HTMLInputElement
    const ProjectNameInput = event.currentTarget.elements[0] as HTMLInputElement
    const DeadlineInput = event.currentTarget.elements[2] as HTMLInputElement
    const data:IProjectDetails = {
      author: AuthorInput.value,
      projectName: ProjectNameInput.value,
      deadline: new Date(DeadlineInput.value),
    }
    
    projectHandler.UpdateProject(state.currentProject.id||0,data).then((project) => {
      projectHandler.FetchProjects().then((projects) => {
        if (project){
        setstate({...state, projects:projects,currentProject:{
          id:project.id||0,
          author:project.author||"",
          deadline:new Date(project.deadline),
          projectName:project.projectName||""
        }
        })
        setProject({
          "id": project.id?.toString()||"",
          "AuthorName": project.author,
          "ProjectName": project.projectName,
          "ProjectDeadline": project.deadline.toISOString().split("T")[0]||"",
          "Project": project.projectName
        })
        }
        
        setToasts(toastsArr.length + 1, "Updated Project" , `Updated ${data.projectName}`, deleteToast)
      })
    })
    toggleEditDrawer()
  }

  function handleProjectChange(event:ChangeEvent<HTMLSelectElement>){
    projectHandler.FetchProjects().then((data) => {
      console.log(data)
      data.forEach((project) => {
        if (project?.projectName == event.target.value) {
        setToasts(2, "Loaded project",`"${project.projectName}" loaded`,deleteToast)
        console.log(project.projectName)
        setstate({...state, projects: data, DetailsFields: {
          "id": project.id?.toString()||"",
          "AuthorName": project?.author,
          "ProjectName": project?.projectName,
          "ProjectDeadline": project?.deadline.toISOString().split("T")[0],
          "Project": project?.projectName
        }, currentProject: {
          id:project.id||0,
          author:project.author||"",
          deadline:new Date(project.deadline),
          projectName:project.projectName||""
        }
          })
          setProject({
            "id": project.id?.toString() || "",
            "AuthorName": project?.author || "",
            "ProjectName": project?.projectName || "",
            "ProjectDeadline": project?.deadline.toISOString().split("T")[0] || "",
            "Project": project?.projectName || ""
          })
          
          return
        }
      })
    })
  }
  
  function SubmitProjectDetails(event: FormEvent) {
    event.preventDefault()
    
    const data:IProjectDetails = {
      author: state.DetailsFields["AuthorName"],
      projectName: state.DetailsFields["ProjectName"],
      deadline: new Date(state.DetailsFields["ProjectDeadline"]),
    }
    const eventType = document.activeElement?.textContent
    if (eventType == "Create") {
      console.log(state.projects.find((item)=>item.id?.toString()||"" == project.id))
      if(state.projects.find((item)=>item.projectName == data.projectName) != null) return
      if(data.projectName == "None") return
      projectHandler.CreateProject(data).then(() => {
        projectHandler.FetchProjects().then((projects) => {
          setstate({...state, projects})
          setToasts(toastsArr.length + 1, "Created new project" , "", deleteToast)
        })
      })
    } else if (eventType == "Update") {
      projectHandler.UpdateProject(parseInt(state.DetailsFields["id"]),data).then(() => {
      
      setToasts(toastsArr.length + 1, "Updated Details"
        , "", deleteToast)
      })
    } 
    
    
  }
  function handleDeleteProject() {
    if(state.projects.length == 1) return
    console.log(state.currentProject,"delete")
    projectHandler.DeleteProject(state.currentProject.id||0).then(() => {
    projectHandler.FetchProjects().then((projects) => {
    console.log(projects)
    setstate({ ...state, projects: projects, currentProject: {
      id:projects[0].id||0,
      author:projects[0].author,
      deadline:projects[0].deadline,
      projectName:projects[0].projectName
    }})
    setProject({
      "id": projects[0].id?.toString()||"",
      "AuthorName": projects[0].author,
      "ProjectName": projects[0].projectName,
      "ProjectDeadline": projects[0].deadline.toISOString().split("T")[0]||"",
      "Project": projects[0].projectName
    })
    setToasts(toastsArr.length+1, `Deleted ${project.ProjectName}`, "", deleteToast)
    })
      toggleModal()
    })   
  }
  function CreateAnalyticsData(PieDataType:"Priority"|"Status") {
    todoHandler.FetchTodosLists(project.ProjectName).then((todos) => {
      let Group1_value = 0,
          Group2_value= 0, 
          Group3_value = 0
      let PieData: { label: string, value: number }[] = []    
      switch (PieDataType) {
        case "Status":
          todos.forEach((todo) => {
            if (todo.status == "Pending") Group1_value++
            if (todo.status == "Completed") Group3_value++
            if (todo.status == "Ongoing") Group2_value++
          })
          if (Group1_value > 0) PieData.push({ label: "Pending", value: Group1_value })
          if (Group2_value > 0) PieData.push({ label: "Ongoing", value: Group2_value })
          if (Group3_value > 0) PieData.push({ label: "Completed", value: Group3_value })
          console.log(todos)
          setstate(prevstate=>{return{
            ...prevstate, PieChartData: {
              data: PieData, colorMap: {
                "Pending": "hsl(350, 88%, 45%)",
                "Ongoing": "hsl(56, 98%, 49%)",
                "Completed": "hsl(90, 77%, 35%)",
              }
            }
          }})
          break;
        case "Priority":
          todos.forEach((todo) => {
            if (todo.priority == "Low") Group1_value++
            if (todo.priority == "High") Group3_value++
            if (todo.priority == "Medium") Group2_value++
          })
          if (Group1_value > 0) PieData.push({ label: "Low", value: Group1_value })
          if (Group2_value > 0) PieData.push({ label: "Medium", value: Group2_value })
          if (Group3_value > 0) PieData.push({ label: "High", value: Group3_value })
          console.log(todos)
          setstate(prevstate=>{return {
            ...prevstate, PieChartData: {
              data: PieData, colorMap: {
                "High": "hsl(350, 88%, 45%)",
                "Medium": "hsl(56, 98%, 49%)",
                "Low": "hsl(90, 77%, 35%)",
              }
            }
          }})
          break;
          
        default:
          break;
      }
      
    })
  }
  function CanDeleteProject() {
    // if (state.projects.find((item) => item.id == project.id)?.projectName == "None") {
    //   return false
    if (state.projects.length == 1) return false
     else return true
  }
  function DateDiff(date1:Date,date2:Date) {
    const DayInMilliseconds = 24 * 60 * 60 * 1000
    let daysDiff = Math.ceil((date1?.getTime() - date2?.getTime())/DayInMilliseconds)
    if (daysDiff < 0 || !daysDiff) daysDiff = 0
    return daysDiff
  }
  return (
    <div className='Profile-Page-Container Side-Content'>
      <Toastlist autoDelete={true} toastsArr={toastsArr} deleteToast={deleteToast} />
      <Drawer isOpen={CreateDrawerIsOpen} toggleDrawer={toggleCreateDrawer}>
        <>
          <h3 className='Drawer-Title'>Create a new project:</h3>
          <br />
          <form onSubmit={HandleCreateProject}>
            <div className='Input-Container'>
              <label htmlFor='ProjectName'>Project Name:</label>
              <input required name="ProjectName" type="text" id='ProjectName' />
            </div>
            <h5 className='Error-Msg'>Project name must be different from other projects</h5>
            <div className='Input-Container'>
              <label htmlFor='ProjectAuthor'>Author:</label>
              <input required name="AuthorName" type="text" id='ProjectAuthor' />
            </div>
            <div className='Input-Container'>
              <label htmlFor='ProjectDeadline'>Project Deadline:</label>
              <input required name="ProjectDeadline" min={new Date().toISOString().split("T")[0]} type="date" id='ProjectDeadline' />
            </div>
            <br />
            <button type='submit'>Create Project</button>
          </form>
        </>
      </Drawer>
      <Drawer isOpen={EditDrawerIsOpen} toggleDrawer={toggleEditDrawer}>
        <>
          <h3 className='Drawer-Title'>Update {state.currentProject.projectName}:</h3>
          <br />
          <form onSubmit={HandleEditProject}>
            <div className='Input-Container'>
              <label htmlFor='ProjectName'>Project Name:</label>
              <input required defaultValue={state.currentProject.projectName} name="ProjectName" type="text" id='ProjectName' />
            </div>
            <div className='Input-Container'>
              <label htmlFor='ProjectAuthor'>Author:</label>
              <input required defaultValue={state.currentProject.author} name="AuthorName" type="text" id='ProjectAuthor' />
            </div>
            <div className='Input-Container'>
              <label htmlFor='ProjectDeadline'>Project Deadline:</label>
              <input required defaultValue={state.currentProject.deadline?.toISOString().split("T")[0]||"0-0-0"} name="ProjectDeadline" min={new Date().toISOString().split("T")[0]} type="date" id='ProjectDeadline' />
            </div>
            <br />
            <button type='submit'>Update Project</button>
          </form>
        </>
      </Drawer>
      <div className='Project-Details'>
        <h3>Project Details</h3>
        
        <div>
          <div className='Input-Container'>
          <label className='Info-Field' htmlFor='project'><b>Select Project:</b></label>
          <select onChange={handleProjectChange} name="project" id="project">
            {state.currentProject.deadline?<option disabled>Select a project</option>:<option selected disabled>Select a project</option>}
            {state.projects.map((project)=>{
              if(project.id == state.currentProject.id){
                return <option selected key={project.id}>{project.projectName}</option>
              }else{
                return <option key={project.id}>{project.projectName}</option>
              }
              
            })}
          </select>
          </div>
          <hr />
          <div className='Input-Container'>
          <label className='Info-Field' htmlFor='ProjectName'><b>Project Name:</b></label>
          <p>{state.DetailsFields["ProjectName"]}</p>
          {/* <input required value={state.DetailsFields["ProjectName"]} onChange={HandleDetailsChange} type="text" name='ProjectName' id='ProjectName' /> */}
        </div>
        <div className='Input-Container'>
          <label className='Info-Field' htmlFor='AuthorName'><b>Author:</b></label>
          <p>{state.DetailsFields["AuthorName"]}</p>
          {/* <input required value={state.DetailsFields["AuthorName"]} onChange={HandleDetailsChange} type="text" name="AuthorName" id="AuthorName" /> */}
        </div>
        <div className='Input-Container'>
          <label className='Info-Field' htmlFor='ProjectDeadline'><b>Project Deadline:</b></label>
          <p>{state.DetailsFields["ProjectDeadline"]}</p>
          {/* <input required min={new Date().toISOString().split("T")[0]} value={state.DetailsFields["ProjectDeadline"]} onChange={HandleDetailsChange} min={new Date().toISOString().split("T")[0]} type="date" name="ProjectDeadline" id="ProjectDeadline" /> */}
        </div>
        <div className='Project-Info-Btns Details'>
          <button onClick={toggleEditDrawer}>Update Project</button>
          <button onClick={toggleCreateDrawer}>Create Project</button>
          <Modal isShowing={isOpen} hideModal={toggleModal}>
            <div className='Confirm-Modal'>
              <h3>Please confirm deleting this project .</h3>
              
                <i>This will also delete the related <strong>tasks</strong>,<strong>schedules</strong> and <strong>notes</strong></i>
              
              <button type='submit' className='Delete-Btn' onClick={handleDeleteProject}>Delete</button>
            </div>
          </Modal>
            <button disabled={!CanDeleteProject()} type='button' onClick={()=>{
              if(CanDeleteProject()) toggleModal()
            }}>Delete Project</button>
        </div>
        </div>
        
        
       
      </div>
      <div className='Project-Summary'>
        <h3>Project Summary</h3>
        <div className='Project-Info-Btns'>
          <button onClick={()=>CreateAnalyticsData("Status")}>Show Status</button>
          <button onClick={()=>CreateAnalyticsData("Priority")}>Show Priority</button>
        </div>
        <PieChart data={state.PieChartData.data}
          outerRadius={100}
          colorMap={state.PieChartData.colorMap}
          innerRadius={40} />
        <hr />
        <h3><code>{DateDiff(state.currentProject.deadline, new Date())}</code>
          {DateDiff(state.currentProject.deadline, new Date()) > 1 ? " days left before deadline"
            :DateDiff(state.currentProject.deadline, new Date()) == 0?" days left before deadline"
            :" day left before deadline"
          }
        </h3>
      </div>
      <div className='Settings-Container'>
        <h3>Customize your theme</h3>
        <div className='Themes-Container'>
          <div onClick={Setthemetemp} className='Theme1'></div>
          <div onClick={Setthemetemp} className='Theme2'></div>
          <div onClick={Setthemetemp} className='Theme3'></div>
          <div onClick={Setthemetemp} className='Theme4'></div>
          <div onClick={Setthemetemp} className='Theme5'></div>
          <div onClick={Setthemetemp} className='Theme6'></div>
          <div onClick={Setthemetemp} className='Theme7'></div>
          <div onClick={Setthemetemp} className='Theme8'></div>
          <div onClick={Setthemetemp} className='Theme9'></div>
          <div onClick={Setthemetemp} className='Theme10'></div>
        </div>
        
      </div>
    
    </div>
  )
}
